module.exports = __webpack_public_path__ + "static/media/fullscreen_exit-white-24dp.f3184a80.svg";